import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer
      className="bg-forest py-24 md:py-28"
      style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}
    >
      <div className="px-6 md:px-12 lg:px-20">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-10 md:gap-8">

          {/* Left — Brand */}
          <div className="md:w-2/5">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://static.readdy.ai/image/1f65bef57b9643672cbad222c3f4355a/5546c377f661db375ddd3ab5f508adc4.png"
                alt="Paw & Co."
                className="h-8 w-auto"
              />
              <span
                className="font-serif text-cream"
                style={{ fontSize: '22px', fontWeight: 700, letterSpacing: '-0.01em' }}
              >
                Paw &amp; Co.
              </span>
            </div>
            <p
              className="font-grotesk leading-relaxed max-w-xs"
              style={{ fontSize: '13px', color: 'rgba(245,240,230,0.6)', letterSpacing: '0.05em' }}
            >
              Premium care since 1994. Curated experiences for the modern pet parent.
            </p>
          </div>

          {/* Center — Logo */}
          <div className="md:w-auto flex md:items-center md:justify-center" style={{ marginRight: '190px' }}>
            <img
              src="https://storage.readdy-site.link/project_files/4682edff-4d72-4c76-93c5-affd5b3908be/b0fc9aa3-f7a4-441c-84cf-1b2625c2078c_a-sophisticated-minimalist-logo-design-f_0Wmj_U7mQLWvJMeTPeWNeQ_i3BFBJP6SxWUHTbvsjPlmw_cover_sd-Phot.png?v=3c9713041eff2bd63746fc17d7b1b092"
              alt="Paw & Co."
              className="w-auto" style={{ height: '240px' }}
            />
          </div>

          {/* Right — CTA */}
          <div className="md:w-auto flex md:items-center" style={{ marginRight: '80px' }}>
            <Link
              to="/contact"
              className="font-grotesk whitespace-nowrap transition-opacity duration-200 hover:opacity-75 cursor-pointer"
              style={{
                backgroundColor: '#A65D37',
                color: '#FFFFFF',
                fontSize: '13px',
                fontWeight: 700,
                letterSpacing: '0.18em',
                fontVariant: 'small-caps',
                textTransform: 'uppercase',
                borderRadius: '0px',
                padding: '13px 38px',
                display: 'inline-block',
              }}
            >
              Book a Session
            </Link>
          </div>

        </div>
      </div>
    </footer>
  );
}
